export const flattenedObjectToArray = <T extends Record<string, any>>(
  obj: T,
  unique = true,
): Array<any> => {
  const reduce = Object.keys(obj).reduce(
    (acc, v) => [
      ...acc,
      ...(obj[v] && typeof obj[v] === 'object'
        ? flattenedObjectToArray(obj[v])
        : [obj[v]]),
    ],
    [],
  );

  return unique ? Array.from(new Set(reduce)) : reduce;
};

export const hasOnlyEmptyValues = <T extends Record<string, any> | null>(
  obj?: T,
  callback = (v: any) => !v,
) => (obj ? flattenedObjectToArray(obj).every(callback) : true);
